<template>
  <!-- 応募 -->
  <div :class="{'my-box': speaker==='my', 'other-box': speaker==='other'}">
    <p class="message"
        :style="{
          'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important', 
          'color': autoColor(speaker==='my' ? color.balloonMy : color.balloonOtr),
          'filter': shadowStyle(color.shadowType)}">{{ formMessageCreate(message) }}</p>
    <div class="cv-box">
      <div class="cv-header">
        <p><span class="mdi mdi-file-document-box-outline" style="margin-right: 4px; font-size: 14px;"></span>入力フォーム</p>
      </div>
      <div class="cv-body" v-if="!companyData">
        <div class="cv-form">
          <span class="require" v-if="companyData.subscribe_required_name">*</span>
          <span class="require -none" v-else>*</span>
          <p class="cv-title">お名前</p>
          <input class="input is-small -right-8px" placeholder="山田" v-model="skInfo.skNameSei"/>
          <input class="input is-small -left-8px"  placeholder="太郎" v-model="skInfo.skNameMei"/>
        </div>
        <div class="cv-form">
          <span class="require" v-if="companyData.subscribe_required_email">*</span>
          <span class="require -none" v-else>*</span>
          <p class="cv-title">Email</p>
          <input class="input is-small" placeholder="taro-yamada@xxx.yyy.jp" v-model="skInfo.skEmail" type="email" maxlength="254"/>
        </div>
        <div class="cv-form">
          <span class="require" v-if="companyData.subscribe_required_tel">*</span>
          <span class="require -none" v-else>*</span>
          <p class="cv-title">TEL</p>
          <input class="input is-small -left-8px" placeholder="080"  v-model="skInfo.skTel1" type="tel" maxlength="4"/>
          <input class="input is-small -left-8px" placeholder="1234" v-model="skInfo.skTel2" type="tel" maxlength="4"/>
          <input class="input is-small -left-8px" placeholder="5678" v-model="skInfo.skTel3" type="tel" maxlength="4"/>
        </div>
        <div class="cv-form auto">
          <a class="privacy-policy" href="https://hr-monster.io/privacy/" target="_blank" rel="noopener">プライバシーポリシー</a>
        </div>
        <div class="button-container">
          <button
            class="button is-info is-fullwidth is-small send-btn"
            @click.once="subscribe()"
            :disabled="isNowButton()||isDisabled">
            <span class="mdi mdi-send" style="margin-right: 4px;"></span>送信する
          </button>
        </div>
      </div>
      <div class="cv-body" v-if="companyData">
        <div class="cv-form" v-if="companyData.subscribe_is_name">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_name">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">お名前</p>
          </div>
          <input class="input is-small -right-8px" placeholder="山田" v-model="skInfo.skNameSei"/>
          <input class="input is-small -left-8px"  placeholder="太郎" v-model="skInfo.skNameMei"/>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_name_phonetic">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_name_phonetic">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">フリガナ</p>
          </div>
          <input class="input is-small -right-8px" placeholder="ヤマダ" v-model="skInfo.skNamePhoneticSei"/>
          <input class="input is-small -left-8px"  placeholder="タロウ" v-model="skInfo.skNamePhoneticMei"/>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_sex">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_sex">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">性別</p>
          </div>
          <b-select size="is-small" v-model="skInfo.skSex" style="width: 100%; text-align: left;">
            <option v-for="(s, key) in sexTypes" :value="key" :key="key">
                {{ s }}
            </option>
          </b-select>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_email">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_email">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">Email</p>
          </div>
          <input class="input is-small" placeholder="taro-yamada@xxx.yyy.jp" v-model="skInfo.skEmail" type="email" maxlength="254"/>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_tel">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_tel">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">TEL</p>
          </div>
          <input class="input is-small -right-8px" placeholder="080"  v-model="skInfo.skTel1" type="tel" maxlength="4"/>
          <input class="input is-small -right-8px" placeholder="1234" v-model="skInfo.skTel2" type="tel" maxlength="4"/>
          <input class="input is-small -right-8px" placeholder="5678" v-model="skInfo.skTel3" type="tel" maxlength="4"/>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_birth">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_birth">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">生年月日</p>
          </div>
          <b-datepicker
            locale="ja-JP"
            style="width: 100%;"
            size="is-small"
            :show-week-number="false"
            placeholder="生年月日"
            icon="calendar-today"
            :focused-date="defaultBirth"
            :day-names="['日', '月', '火', '水', '木', '金', '土']"
            :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
            v-model="skInfo.skBirth">
          </b-datepicker>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_address">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_address">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">住所</p>
          </div>
          <div style="display: flex; flex-wrap: wrap; width: 100%;">
            <b-select size="is-small" style="margin-bottom: 4px;" v-model="skInfo.skPrefectures">
              <option v-for="pre in prefectures" :key="pre" :value="pre">
                {{pre}}
              </option>
            </b-select>
            <input class="input is-small" placeholder="港区 西新橋 X-XX" v-model="skInfo.skAddress" maxlength="300"/>
          </div>
        </div>
        <div class="cv-form" v-if="companyData.subscribe_is_message">
          <div style="display: flex; width: 80px;">
            <span class="require" v-if="companyData.subscribe_required_message">*</span>
            <span class="require -none" v-else>*</span>
            <p class="cv-title">備考</p>
          </div>
          <input class="input is-small" placeholder="カジュアルにお話を聞きたい" v-model="skInfo.skMsg" maxlength="50"/>
        </div>
        <div class="cv-form auto" style="flex-direction: column;">
          <button
            class="button is-info is-fullwidth is-small"
            @click="toggleScreen"
            :disabled="isNowButton()||isDisabled">
            <span class="mdi mdi-chevron-right" style="margin-right: 4px;"></span>次へ
          </button>
        </div>
        <div class="cv-form auto">
          <a class="privacy-policy" href="https://hr-monster.io/privacy/" target="_blank" rel="noopener">プライバシーポリシー</a>
        </div>
        <!-- 入力確認画面 -->
        <transition name="fade">
          <div v-if="toggleFlg" class="verification-screen">
            <p class="verification_text">以下の内容で情報を送信いたします。</p>
            <article>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_name">
                  <p class="item">お名前</p>
                  <p class="answer">{{skInfo.skName}}</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_name_phonetic">
                  <p class="item">フリガナ</p>
                  <p class="answer">{{skInfo.skNamePhonetic}}</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_sex">
                  <p class="item">性別</p>
                  <p v-if="skInfo.skSex == 0" class="answer">未選択</p>
                  <p v-else-if="skInfo.skSex == 1" class="answer">男性</p>
                  <p v-else-if="skInfo.skSex == 2" class="answer">女性</p>
                  <p v-else-if="skInfo.skSex == 3" class="answer">選択しない</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_email">
                  <p class="item">Email</p>
                  <p class="answer">{{skInfo.skEmail}}</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_tel">
                  <p class="item">TEL</p>
                  <p class="answer">{{skInfo.skTel}}</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_birth">
                  <p class="item">生年月日</p>
                  <p class="answer">{{displayBirthday(skInfo.skBirth)}}</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_address">
                  <p class="item">住所</p>
                  <p class="answer">{{(skInfo.skPrefectures === 'その他' ? '' : skInfo.skPrefectures) + skInfo.skAddress}}</p>
                </div>
              </div>
              <div class="item-container">
                <div class="item-wrapper" v-if="companyData.subscribe_is_message">
                  <p class="item">備考</p>
                  <p class="answer">{{skInfo.skMsg}}</p>
                </div>
              </div>
            </article>
            <div class="button-container">
              <button
                class="button is-info is-fullwidth is-small send-btn"
                @click.once="subscribe()"
                :disabled="isNowButton()||isDisabled">
                <span class="mdi mdi-send" style="margin-right: 4px;"></span>送信する
              </button>
              <button
                class="button is-danger is-fullwidth is-small retype-btn"
                @click="toggleScreen"
                :disabled="isNowButton()||isDisabled">
                <span class="mdi mdi-chevron-left" style="margin-right: 4px;"></span>再入力する
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import hex2rgb from "@/functions/hex2rgb"
// 外部関数
import {
  autoColor,
  shadowStyle,
  isNowButton,
  formMessageCreate
} from "@/functions/balloonFunc"

export default {
  name: "CVParts",
  props: ['parameter', 'message', 'speaker', 'color', 'lastIndex', 'logIndex', 'isBot', 'skInfo', 'isDemo', 'companyData', 'renkeiID', 'roboArguments'],
  data () {
    return {
      sexTypes  : ['', '男性', '女性', '選択しない'],
      toggleFlg: false,
      // TODO: どこかにまとめておきたい
      prefectures: [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県',
        'その他',
      ],
      defaultBirth: null
    }
  },
  mounted() {
    if (this.parameter && this.parameter['default_birth']) {
      this.defaultBirth = new Date(this.parameter['default_birth'])
    } else {
      this.defaultBirth = new Date()
    }
    this.fetchLocalStorageToSkInfo()
  },
  methods: {
    formMessageCreate (m) {
      return formMessageCreate(m, this.roboArguments)
    },
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    initScenario () {
      this.$emit('initScenario')
    },
    subscribe () {
      this.setLocalStorageFromSkInfo()
      this.$emit('subscribe')
    },
    toggleScreen () {
      this.skInfo.skTel = this.skInfo.skTel1 + this.skInfo.skTel2 + this.skInfo.skTel3
      this.skInfo.skName = this.skInfo.skNameSei + this.skInfo.skNameMei
      this.skInfo.skNamePhonetic = this.skInfo.skNamePhoneticSei + this.skInfo.skNamePhoneticMei
      this.toggleFlg = !this.toggleFlg
    },
    displayBirthday (birthday) {
      if (birthday === null) {
        return ''
      } else {
        return birthday.getFullYear() + '/' + (birthday.getMonth() + 1) + '/' + birthday.getDate()
      }
    },
    fetchLocalStorageToSkInfo() {
      const tmpskNameSei = localStorage.getItem('SKI_NM_SEI')
      if((!this.skInfo.skNameSei || this.skInfo.skNameSei == "") && tmpskNameSei) {
        this.skInfo.skNameSei = tmpskNameSei
      }
      const tmpskNameMei = localStorage.getItem('SKI_NM_MEI')
      if((!this.skInfo.skNameMei || this.skInfo.skNameMei == "") && tmpskNameMei) {
        this.skInfo.skNameMei = tmpskNameMei
      }
      const tmpskNamePSei = localStorage.getItem('SKI_NM_PS')
      if((!this.skInfo.skNamePhoneticSei || this.skInfo.skNamePhoneticSei == "") && tmpskNamePSei) {
        this.skInfo.skNamePhoneticSei = tmpskNamePSei
      }
      const tmpskNamePMei = localStorage.getItem('SKI_NM_PM')
      if((!this.skInfo.skNamePhoneticMei || this.skInfo.skNamePhoneticMei == "") && tmpskNamePMei) {
        this.skInfo.skNamePhoneticMei = tmpskNamePMei
      }
      const tmpskSex = localStorage.getItem('SKI_SEX')
      if((!this.skInfo.skSex || this.skInfo.skSex == "") && tmpskSex) {
        this.skInfo.skSex = tmpskSex
      }
      const tmpskEmail = localStorage.getItem('SKI_EMAIL')
      if((!this.skInfo.skEmail || this.skInfo.skEmail == "") && tmpskEmail) {
        this.skInfo.skEmail = tmpskEmail
      }
      const tmpskTel1 = localStorage.getItem('SKI_TEL1')
      if((!this.skInfo.skTel1 || this.skInfo.skTel1 == "") && tmpskTel1) {
        this.skInfo.skTel1 = tmpskTel1
      }
      const tmpskTel2 = localStorage.getItem('SKI_TEL2')
      if((!this.skInfo.skTel2 || this.skInfo.skTel2 == "") && tmpskTel2) {
        this.skInfo.skTel2 = tmpskTel2
      }
      const tmpskTel3 = localStorage.getItem('SKI_TEL3')
      if((!this.skInfo.skTel3 || this.skInfo.skTel3 == "") && tmpskTel3) {
        this.skInfo.skTel3 = tmpskTel3
      }
      const tmpskBirth = localStorage.getItem('SKI_BIRTH')
      if((!this.skInfo.skBirth || this.skInfo.skBirth == "") && tmpskBirth) {
        this.skInfo.skBirth = new Date(Date.parse(tmpskBirth))
      }
      const tmpskPrefectures = localStorage.getItem('SKI_PREF')
      if((!this.skInfo.skPrefectures || this.skInfo.skPrefectures == "") && tmpskPrefectures) {
        this.skInfo.skPrefectures = tmpskPrefectures
      }
      const tmpskAddress = localStorage.getItem('SKI_ADDR')
      if((!this.skInfo.skAddress || this.skInfo.skAddress == "") && tmpskAddress) {
        this.skInfo.skAddress = tmpskAddress
      }
      const tmpskMsg = localStorage.getItem('SKI_MSG')
      if((!this.skInfo.skMsg || this.skInfo.skMsg == "") && tmpskMsg) {
        this.skInfo.skMsg = tmpskMsg
      }
    },
    setLocalStorageFromSkInfo() {
      localStorage.setItem('SKI_NM_SEI', this.skInfo.skNameSei)
      localStorage.setItem('SKI_NM_MEI', this.skInfo.skNameMei)
      localStorage.setItem('SKI_NM_PS', this.skInfo.skNamePhoneticSei)
      localStorage.setItem('SKI_NM_PM', this.skInfo.skNamePhoneticMei)
      localStorage.setItem('SKI_SEX', this.skInfo.skSex)
      localStorage.setItem('SKI_EMAIL', this.skInfo.skEmail)
      localStorage.setItem('SKI_TEL1', this.skInfo.skTel1)
      localStorage.setItem('SKI_TEL2', this.skInfo.skTel2)
      localStorage.setItem('SKI_TEL3', this.skInfo.skTel3)
      localStorage.setItem('SKI_BIRTH', this.skInfo.skBirth)
      localStorage.setItem('SKI_PREF', this.skInfo.skPrefectures)
      localStorage.setItem('SKI_ADDR', this.skInfo.skAddress)
      localStorage.setItem('SKI_MSG', this.skInfo.skMsg)
    }
  },
  computed: {
    isDisabled () {
      return (
        (this.companyData.subscribe_required_name          ? (this.skInfo.skNameSei.length < 1 && this.skInfo.skNameMei.length < 1         && this.companyData.subscribe_is_name)          : false) ||
        (this.companyData.subscribe_required_name_phonetic ? (this.skInfo.skNamePhoneticSei.length < 1 && this.skInfo.skNamePhoneticMei.length < 1 && this.companyData.subscribe_is_name_phonetic) : false) ||
        (this.companyData.subscribe_required_email         ? (this.skInfo.skEmail.length < 1         && this.companyData.subscribe_is_email)         : false) ||
        (this.companyData.subscribe_required_tel           ? (this.skInfo.skTel1.length < 1 && this.skInfo.skTel2.length < 1 && this.skInfo.skTel3.length < 1 && this.companyData.subscribe_is_tel)  : false) ||
        (this.companyData.subscribe_required_email         ? (this.skInfo.skEmail.indexOf('@') == -1 && this.companyData.subscribe_is_email)         : false) ||
        (this.companyData.subscribe_required_birth         ? (!this.skInfo.skBirth                   && this.companyData.subscribe_is_birth)         : false) ||
        (this.companyData.subscribe_required_address       ? ((this.skInfo.skAddress.length < 1 || this.skInfo.skPrefectures.length < 1) && this.companyData.subscribe_is_address) : false) ||
        (this.companyData.subscribe_required_sex           ? (!this.skInfo.skSex                     && this.companyData.subscribe_is_sex)           : false) ||
        (this.companyData.subscribe_required_message       ? (this.skInfo.skMsg.length < 1           && this.companyData.subscribe_is_message)       : false)
      )
    }
  }
};
</script>

<style lang="scss" scoped>
.message {
  text-align: left;
  padding: 16px;
  width: auto;
  max-width: -webkit-fill-available;
  word-wrap: break-word;
  border-radius: 8px;
  font-size: smaller;
  transition: 0.7s;
  margin-bottom: 8px;
}
.my-box {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-right: 10px;
}
.other-box {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
}
.cv-box {
  display: flex;
  flex-direction: column;
  padding: 16px;
  transition: 0.7s;
  background: #fff;
  position: relative;
  border-radius: 8px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}
.cv-header {
  padding: 8px;
  border-radius: 8px;
  background: #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  p {
    font-size: 14px;
    font-weight: 600;
  }
}
.cv-body {
  background: #fff;
}
.cv-form {
  display: flex; justify-content: space-between; align-items: center; margin-top: 16px;
  &.auto {
    height: auto;
  }
}
.cv-title {
  width: 100px; font-size: 13px; text-align: left;
}
.privacy-policy {
  width: 100%; font-size: 12px; text-align: right;
}
.require {
  color: red; margin-right: 2px;
  &.-none {
    visibility: hidden;
  }
}
.verification-screen {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #fff;
  text-align: left;
  padding: 16px;
  article {
    font-size: 13px;
    word-wrap: break-word;
  }
}
.verification_text {
  height: 38px;
  font-size: 14px;
  padding: 8px;
  background: rgba(200, 200, 200, 0.4);
}
.item-wrapper {
  display: flex;
  align-items: center;
  height: 27px;
  .item {
    width: 100px;
    padding-left: 8px;
  }
  .answer {
    width: 65%;
    font-weight: bold;
  }
}
.retype-btn {
  margin-top: 8px;
}
.item-container {
  margin-top: 16px;
}
.button-container {
  margin-top: 16px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/CVParts.vue